/* Plays a soft 2-tone chime via Web Audio API. No external audio file needed. */
let _ctx = null;

function _getCtx() {
  if (typeof window === "undefined") return null;
  if (_ctx) return _ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  _ctx = new AC();
  return _ctx;
}

function _tone(ctx, freq, startAt, durMs, peakGain = 0.18) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  const t = ctx.currentTime + startAt;
  const dur = durMs / 1000;
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(peakGain, t + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.001, t + dur);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + dur);
}

/* Play a friendly two-tone chime (E5 -> A5). */
export function playChime() {
  try {
    const ctx = _getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") ctx.resume();
    _tone(ctx, 659.25, 0.0, 220);
    _tone(ctx, 880.0, 0.13, 320);
  } catch (err) { /* chime is non-critical */ console.debug("[chime] play failed", err); }
}
